import FilterSpa from './FilterSpa';

export default FilterSpa;
